import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Container, Divider, Grid, Link, Paper, Stack, Typography} from 'views/components';
import {Translate, useParams} from 'views/module';

import {parseJobData} from './sections/Body/util';
import {Footer, Header} from './sections';
import JobDetailSkeleton from './components/JobDetailSkeleton';
import JobDetailMainColumn from './sections/Body/JobDetailMainColumn';

import backend from 'utils/backend';

const JobDetail = (props) => {
  const progressWrap = props.statusProgressWrap;
  const params = useParams();
  const jobRn = params.jobRn;

  const [job, setJob] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  React.useEffect(() => {
    progressWrap(async () => {
      const jobData = await backend.career.getJob(jobRn); // {job: {}, jobRn: string}

      setJob(jobData.job);
      setIsLoading(false);
    }, []);
  }, []);

  let jobDataParsed;
  let startDate;
  let requirements;
  let location;
  let description;
  if (!isLoading) {
    jobDataParsed = parseJobData(job);
    startDate = job.startDate;
    requirements = job.requirements;
    location = job.location;
    description = job.description;
  }
  return (
    <Stack sx={{background: 'linear-gradient(180deg, #F6F2EF 0%, #F4EFEA 100%)', minHeight: '100vh'}}>
      <Header />
      <Container
        sx={{
          background: 'linear-gradient(180deg, #F6F2EF 0%, #F4EFEA 100%)',
          py: {xs: 6, md: 10},
          height: '100%',
          flexGrow: 1,
        }}
      >
        <Box sx={{maxWidth: 960, mx: 'auto'}}>
          <Grid container spacing={4}>
            {/* Main column */}
            {/* Display when loading data */}
            {
              isLoading && <JobDetailSkeleton/>
            }
            {/* Display when data is loaded */}
            {
              !isLoading && <JobDetailMainColumn
                jobDataParsed={jobDataParsed}
                startDate={startDate}
                requirements={requirements}
                location={location}
                description={description}
              />
            }
            {/* Sticky apply card */}
            <Grid size={{xs: 12, lg: 4}}>
              <Box sx={{position: {lg: 'sticky'}, top: {lg: 24}}}>
                <Link
                  href={`/caregiver-application?job=${jobRn}`}
                  underline="none"
                  sx={{display: 'block'}}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      'p': 3,
                      'borderRadius': 3,
                      'cursor': 'pointer',
                      'transition': 'box-shadow 200ms ease, transform 200ms ease',
                      '&:hover': {
                        boxShadow: 3,
                        transform: 'translateY(-1px)',
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      sx={{
                        'mb': 1,
                        'transition': 'color 200ms ease',
                        '&:hover': {color: '#DA7757'},
                      }}
                    >
                      <Translate expression='jobDetail.ApplyButton.Title' />
                    </Typography>
                    <Typography variant="body2" sx={{color: 'text.secondary'}}>
                      <Translate expression='jobDetail.ApplyButton.ClickHere' />
                    </Typography>

                    <Divider sx={{my: 2}} />

                    <Typography variant="caption" sx={{color: 'text.secondary'}}>
                      <Translate expression='jobDetail.ApplyButton.TakenTo' />
                    </Typography>
                  </Paper>
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Footer />
    </Stack>
  );
};

JobDetail.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(JobDetail));
